var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useCallback, useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { ERoleTypes, } from "../../../types";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectMatchState, setMatchState } from "../../../store/match";
import { useErrorHandler } from "../../../hooks/useErrorHandler";
import { setPlayerRole } from "../../../api";
const ExpandedContainer = styled.div `
  z-index: 1000;
  //overflow: auto;
`;
const rolesList = [
    ERoleTypes.DON,
    ERoleTypes.MAFIA,
    ERoleTypes.SHERIFF,
    ERoleTypes.DOCTOR,
    ERoleTypes.LADY,
    ERoleTypes.JAILER,
    ERoleTypes.BOMB,
    ERoleTypes.WEREWOLF,
    ERoleTypes.CIVILIAN,
    ERoleTypes.SWITCHMAN,
];
export function Roles({ player, onClose, players }) {
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const [selectedRole, setSelectedRole] = useState();
    const matchState = useAppSelector(selectMatchState);
    const rolesList = (matchState === null || matchState === void 0 ? void 0 : matchState.roles) || [];
    const allPlayers = (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [];
    // const onPlayerSelect = async (role: ERoleTypes) => {
    //   if (player) {
    //     // console.log('PlayerRole onRoleChange', e.target.value)
    //   }
    // }
    // useEffect(() => {
    //   if (selectedRole !== ERoleTypes.DEFAULT) {
    //     onPlayerSelect(selectedRole)
    //   }
    // }, [player])
    const onRoleChange = useCallback((role) => {
        setSelectedRole(role);
        if (players) {
            players.forEach((p) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield setPlayerRole({
                        playerId: (p === null || p === void 0 ? void 0 : p.id) || "",
                        role,
                    });
                    // console.log('PlayerRole onRoleChange', response)
                    dispatch(setMatchState(response));
                }
                catch (err) {
                    errorHandler(err);
                    console.error("PlayerRole onRoleChange error", err.response);
                }
            }));
        }
        onClose === null || onClose === void 0 ? void 0 : onClose(player);
    }, [players]);
    return (_jsx(Paper, { children: _jsx(TableContainer, Object.assign({ sx: { minWidth: 300, maxHeight: "70vh" } }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0420\u043E\u043B\u044C" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E" }))] }) }), _jsx(TableBody, { children: rolesList.map((role) => (_jsxs(TableRow, Object.assign({ id: role.machineName, onClick: () => onRoleChange(role.machineName) }, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Button, Object.assign({ variant: "outlined", onClick: () => null }, { children: role.name })) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: allPlayers.filter((p) => role.machineName === p.role).length }))] }), role.machineName))) })] }) })) }));
}
